import { SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

type Props = {
  fileUrl: string;
};

export default function PDFViewer({ fileUrl }: Props) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {({
          CurrentPageInput,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          NumberOfPages,
          ShowSearchPopover,
          Zoom,
          ZoomIn,
          ZoomOut,
        }) => {
          return (
            <div
              className="rpv-toolbar"
              role="toolbar"
              aria-orientation="horizontal"
            >
              <div className="rpv-toolbar__left">
                <div className="rpv-toolbar__item">
                  <ShowSearchPopover />
                </div>
                <div className="rpv-toolbar__item">
                  <GoToPreviousPage />
                </div>
                <div className="rpv-toolbar__item">
                  <CurrentPageInput />{" "}
                  <span className="rpv-toolbar__label">
                    / <NumberOfPages />
                  </span>
                </div>
                <div className="rpv-toolbar__item">
                  <GoToNextPage />
                </div>
              </div>
              <div className="rpv-toolbar__center">
                <div className="rpv-toolbar__item">
                  <ZoomOut />
                </div>
                <div className="rpv-toolbar__item">
                  <Zoom />
                </div>
                <div className="rpv-toolbar__item">
                  <ZoomIn />
                </div>
              </div>
              <div className="rpv-toolbar__right">
                <div className="rpv-toolbar__item">
                  <EnterFullScreen />
                </div>
              </div>
            </div>
          );
        }}
      </Toolbar>
    ),
  });

  // Using the version matching the installed pdfjs-dist dependency
  const pdfjsVersion = "3.11.174";

  return (
    <div className="h-full w-full overflow-hidden">
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}
      >
        <Viewer
          fileUrl={fileUrl}
          plugins={[defaultLayoutPluginInstance]}
          defaultScale={SpecialZoomLevel.ActualSize}
        />
      </Worker>
    </div>
  );
}
